<template>
  <div class="table_wrap">
    <el-table :data="boardData"
              class="list-table"
              header-cell-class-name="list-header"
              empty-text="데이터가 없습니다."
              @selection-change="tableSelectChange"
              height="695"
    >
      <el-table-column
          class="table_no"
          type="index"
          label="No"
          min-width="45"
          class-name="num text-center"
          :index="tableIdx"
      >
      </el-table-column>
      <el-table-column min-width="155" label="언어" prop="Language.c_lang_ko" class-name="text-center">
      </el-table-column>
      <el-table-column min-width="155" label="제목" prop="wr_subject" class-name="text-center"></el-table-column>
      <el-table-column min-width="155" label="아이디유형"  class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{returnMemberType(scope.row.Writer.Social)}}
                    </span>
        </template>
      </el-table-column>
      <el-table-column min-width="155" label="아이디" prop="Writer.mb_id" class-name="text-center"></el-table-column>
      <el-table-column min-width="155" label="닉네임" prop="Writer.mb_nick" class-name="text-center"></el-table-column>
      <el-table-column label="작성일자" min-width="150" class-name="text-center">
        <template slot-scope="scope">
                    <span>
                        {{returnDateUnix(scope.row.created_at, 'YYYY-MM-DD HH:mm')}}
                    </span>
        </template>
      </el-table-column>
      <el-table-column min-width="155" label="상태" prop="wr_subject" class-name="text-center">

        <template slot-scope="scope">
                    <span>
                        {{ returnStatus(scope.row.Comment) }}
                    </span>
        </template>

      </el-table-column>

      <el-table-column label="상세" min-width="90" class-name="text-center">
        <template slot-scope="scope">
          <div class="row-info">
            <el-button @click="goDetail(scope.row)">
              정보
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import util from "@/mixins/util";
import memberUtil from "@/components/member/memberUtil";
import dateMixins from "@/mixins/dateMixins";
export default {
  name: "BoardListDefaultLayout",
  mixins: [memberUtil,dateMixins],
  components: {},
  inject: {
    setPage: {
      default: () => {
      }
    },
    boardListSetData: {
      default: () => {
      }
    },
    setFilter: {
      default: () => {
      }
    },
  },
  provide() {
    return {}
  },
  props: {
    boardType: '',
    boardData: {
      default: () => {
        return []
      }
    },
    paginationData: {
      default: () => {
        return {total: 0, page: 0, size: 0,}
      }
    },
  },
  data() {
    return {}
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    tableIdx(index) {
      return this.paginationData.total - index - (this.paginationData.page - 1) * this.paginationData.size;
    },
    tableSelectChange(row) {
      this.selectArr = [];
      util.Array.each(row, (obj, index, arr) => {
        this.selectArr.push(obj.wr_id);
      });
      this.boardListSetData('selectArr', this.selectArr)
    },
    returnDate(date = null) {
      if (!date) {
        return '';
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm')
      // return moment.unix(date).tz(this.HomeAirport.timezone).format('YYYY-MM-DD HH:mm')
    },

    goDetail(row) {
      let url = !util.isEmpty(row.Comment.List) ? `/board/qna/${row.wr_id}` : `/board/qna/create/${row.wr_id}`
      this.$router.push(url)
    },
    returnStatus(Comment){
      return !util.isEmpty(Comment.List) ? "완료" : '-'
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>